import { combineReducers } from 'redux';
import reducerFetch from './reducerFetch';

const rootReducer = combineReducers({ reducerFetch });

export default rootReducer;
